export const ACCESS_TOKEN = "ACCESS_TOKEN"
export const SIGNIN_USER = "SIGNIN_USER"
export const LATEST_VERSION = "LATEST_VERSION_IGNORE"
export const LATEST_SIGNIN_TIME = "LATEST_SIGNIN_TIME_IGNORE"

export const REDIRECT_URI = "REDIRECT_URI"
